/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  Alert,
  AlertIcon,
  Box,
  Button,
  CircularProgress,
  Flex,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  List,
  ListItem,
  Spinner,
  Tag,
  TagCloseButton,
  TagLabel,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate, useParams } from 'react-router-dom';
import _ from 'lodash';
import { useFormValidationToast } from '../../../services/actionToast';
import { InputForm } from '../../inputs/forms/InputForm';
import { FormButton } from '../../buttons/FormButton';
import { ReturnButton } from '../../buttons/ReturnButton';
import { useFetch } from '../../../hooks/useFetch';
import { SelectInputForm } from '../../inputs/forms/SelectInputForm';
import { MaskedInputForm } from '../../inputs/forms/MaskedInputForm';
import { ImageInputForm } from '../../inputs/forms/ImageInputForm';
import { SwitchInputForm } from '../../inputs/forms/SwitchInputForm';
import AlertModal from '../../AlertModal';
import { PageTitle } from '../../PageTitle';
import { FormBox } from '../../formBox';
import { FormHeading } from '../../formHeading';

interface SecretaryFormProps {
  defaultValues?: any;
}

interface FormInputsProps {
  name: string;
  value: any;
  placeholder?: string;
  label: string;
  yup: any;
}

export default function SecretaryForm({ defaultValues }: SecretaryFormProps) {
  const validationToast = useFormValidationToast();
  const baseUrl = '/v1/admin/secretaries';
  const { requestApi: reqApiSecretaries, error: errorSecretaries } = useFetch(baseUrl, {
    actionFeedback: false,
  });
  const { requestApi: reqApiCodepost, error: errorCodepost } = useFetch('/v1/client/address');
  const { requestApi: reqApiUsers } = useFetch('/v1/admin/users');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { itemId } = useParams();
  const navigate = useNavigate();
  const [images, setImages] = useState<any>('');
  const [loadingCodepost, setLoadingCodepost] = useState<any>(false);
  const [uploading, setUploading] = useState<any>(false);
  const [address, setAddress] = useState<any>({});
  const [isFirstRender, setIsFirstRender] = useState(true);
  // Estados para busca e seleção de responsáveis
  const [selectedExistingUsers, setSelectedExistingUsers] = useState<any[]>([]);
  const [userSearchResults, setUserSearchResults] = useState<any[]>([]);
  const [searchingUsers, setSearchingUsers] = useState(false);
  const [eligibleUsers, setEligibleUsers] = useState<any[]>([]);
  const [loadingEligibleUsers, setLoadingEligibleUsers] = useState(false);

  const optionsOrgan = [
    {
      label: 'Federal',
      value: 'FEDERAL',
    },
    {
      label: 'Estadual',
      value: 'ESTADUAL',
    },
    {
      label: 'Municipal',
      value: 'MUNICIPAL',
    },
  ];

  const yupschema: any = {};
  const defaultValuesSchema: any = {};

  const formInputs: FormInputsProps[] = [
    {
      name: 'name',
      value: defaultValues?.name ?? '',
      placeholder: 'Nome da secretaria',
      label: 'Nome',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'site',
      value: defaultValues?.site ?? '',
      placeholder: 'Site da secretaria',
      label: 'Site',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'organ',
      value: defaultValues?.organ
        ? optionsOrgan.find((item) => item.value === defaultValues?.organ)
        : null,
      placeholder: 'Órgão da secretaria',
      label: 'Órgão',
      yup: Yup.mixed().required('Este campo é obrigatório!'),
    },
    {
      name: 'cell_phone',
      value: defaultValues?.cell_phone ?? '',
      placeholder: 'Telefone da secretaria',
      label: 'Telefone',
      yup: Yup.string(),
    },
    {
      name: 'code_post',
      value: defaultValues?.address?.code_post ?? '',
      placeholder: 'CEP da secretaria',
      label: 'CEP',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'city_id',
      value: defaultValues?.address?.city?.id ?? '',
      placeholder: '',
      label: 'Cidade',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'city_name',
      value: defaultValues?.address?.city?.name ?? '',
      placeholder: 'Cidade da secretaria',
      label: 'Cidade',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'state_name',
      value: defaultValues?.address?.city?.state?.name ?? '',
      placeholder: 'Estado da secretaria',
      label: 'Estado',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'street',
      value: defaultValues?.address?.street ?? '',
      placeholder: 'Rua da secretaria',
      label: 'Rua',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'number',
      value: defaultValues?.address?.number ?? '',
      placeholder: 'Número da secretaria',
      label: 'Número',
      yup: Yup.string(),
    },
    {
      name: 'district',
      value: defaultValues?.address?.district ?? '',
      placeholder: 'Bairro da secretaria',
      label: 'Bairro',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'complement',
      value: defaultValues?.address?.complement ?? '',
      placeholder: 'Complemento da secretaria',
      label: 'Complemento',
      yup: Yup.string(),
    },
    {
      name: 'responsible',
      value: defaultValues?.responsible ?? '',
      placeholder: 'Nome do responsável',
      label: 'Nome',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'email',
      value: defaultValues?.email ?? '',
      placeholder: 'Email do responsável',
      label: 'Email',
      yup: Yup.string().email('Email inválido').required('Este campo é obrigatório!'),
    },
    {
      name: 'responsible_phone',
      value: defaultValues?.responsible_phone ?? '',
      placeholder: 'Telefone do responsável',
      label: 'Telefone',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'function',
      value: defaultValues?.function ?? 'Responsável pela secretaria',
      placeholder: 'Função do responsável',
      label: 'Função',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'image',
      value: defaultValues?.image?.original ?? null,
      placeholder: '',
      label: 'Brasão',
      yup: Yup.mixed().nullable(),
    },
    {
      name: 'status',
      value: defaultValues?.status ?? true,
      label: 'Status',
      yup: Yup.boolean(),
    },
  ];

  formInputs.forEach((object) => {
    yupschema[object.name] = object.yup;
    defaultValuesSchema[object.name] = object.value;
  });
  const schema = Yup.object().shape(yupschema);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValuesSchema,
  });

  const name = formInputs.find((field) => field.name === 'name');
  const cellphone = formInputs.find((field) => field.name === 'cell_phone');
  const site = formInputs.find((field) => field.name === 'site');
  const organ = formInputs.find((field) => field.name === 'organ');
  const codePost = formInputs.find((field) => field.name === 'code_post');
  const city = formInputs.find((field) => field.name === 'city_name');
  const state = formInputs.find((field) => field.name === 'state_name');
  const street = formInputs.find((field) => field.name === 'street');
  const number = formInputs.find((field) => field.name === 'number');
  const district = formInputs.find((field) => field.name === 'district');
  const complement = formInputs.find((field) => field.name === 'complement');
  const responsible = formInputs.find((field) => field.name === 'responsible');
  const responsibleEmail = formInputs.find((field) => field.name === 'email');
  const responsiblePhone = formInputs.find((field) => field.name === 'responsible_phone');
  const responsibleFunction = formInputs.find((field) => field.name === 'function');
  const image = formInputs.find((field) => field.name === 'image');
  const status = formInputs.find((field) => field.name === 'status');

  // Função para recarregar responsáveis vinculados
  const reloadResponsibles = React.useCallback(async () => {
    if (!itemId) return;

    try {
      const response = await reqApiUsers(
        'get',
        {},
        `/v1/admin/secretaries/${itemId}/additional-responsibles`
      );
      if (response?.data?.data && Array.isArray(response.data.data)) {
        setSelectedExistingUsers(response.data.data);
      }
    } catch {
      setSelectedExistingUsers([]);
    }
  }, [itemId, reqApiUsers]);

  const onSubmit = async (values: any) => {
    const params = {
      ...values,
      organ: values.organ.value,
      address: {
        code_post: values.code_post,
        city_id: Number(values.city_id),
        street: values.street,
        number: values.number,
        district: values.district,
        complement: values.complement,
      },
      // Adicionar responsáveis selecionados
      ...(selectedExistingUsers.length > 0
        ? {
            existing_user_ids: selectedExistingUsers.map((u) => u.id),
          }
        : {}),
      code_post: _,
      city_id: _,
      city_name: _,
      state_name: _,
      street: _,
      number: _,
      district: _,
      complement: _,
      image: _,
    };
    const { status: resStatus, data } = await reqApiSecretaries(
      defaultValues?.name ? 'put' : 'post',
      params,
      defaultValues?.name ? `${baseUrl}/${itemId}` : null
    );

    // Verificar se houve erro antes de continuar
    if (resStatus !== 200 && resStatus !== 201) {
      onOpen();
      return;
    }

    // Se chegou aqui, foi sucesso - fazer upload de imagem se necessário
    if (images) {
      setUploading(true);
      const apiUrlId = itemId ?? data?.data?.id;
      await reqApiSecretaries('put', { file: images.toString() }, `${baseUrl}/${apiUrlId}/images`);
      setUploading(false);
    }

    // Recarregar responsáveis após salvar com sucesso
    await reloadResponsibles();

    onOpen();
  };

  const getCep = async (cep) => {
    const { data, status: resStatus } = await reqApiCodepost('get', { params: { code_post: cep } });
    if (resStatus === 200) {
      setAddress(data?.data);
    } else {
      setAddress({});
    }
    setLoadingCodepost(false);
  };

  // Buscar usuários com debounce
  const searchUsers = React.useMemo(
    () =>
      _.debounce(async (searchTerm: string) => {
        if (!searchTerm || searchTerm.length < 3) {
          setUserSearchResults([]);
          return;
        }

        setSearchingUsers(true);
        try {
          // Filtrar apenas por group_id 6 (Responsável pela Secretaria)
          const params: any = {
            q: searchTerm,
            exclude_responsible: true,
            group_id: 6,
          };
          const response = await reqApiUsers('get', { params });
          setUserSearchResults(response?.data?.data || []);
        } catch {
          setUserSearchResults([]);
        } finally {
          setSearchingUsers(false);
        }
      }, 500),
    [reqApiUsers]
  );

  const handleSelectUser = (user: any) => {
    const alreadySelected = selectedExistingUsers.find((u) => u.id === user.id);
    if (alreadySelected) {
      return;
    }

    setSelectedExistingUsers([...selectedExistingUsers, user]);
    setUserSearchResults([]);
  };

  const handleRemoveUser = (userId: number) => {
    const updated = selectedExistingUsers.filter((u) => u.id !== userId);
    setSelectedExistingUsers(updated);
  };

  const handleUserSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = e.target.value;
    if (searchTerm.length === 0) {
      setUserSearchResults([]);
      return;
    }

    searchUsers(searchTerm);
  };

  useEffect(() => {
    if (defaultValues?.name) {
      reset(defaultValuesSchema);
      getCep(watch('code_post').replace(/\D/g, ''));
    }
  }, [defaultValues]);

  // Carregar responsáveis existentes quando estiver editando
  useEffect(() => {
    const isEditing = !!itemId;
    if (isEditing && itemId) {
      const loadResponsibles = async () => {
        try {
          const users: any[] = [];

          // Carregar responsáveis vinculados à secretaria
          try {
            const response = await reqApiUsers(
              'get',
              {},
              `/v1/admin/secretaries/${itemId}/additional-responsibles`
            );
            if (response?.data?.data && Array.isArray(response.data.data)) {
              users.push(...response.data.data);
            }
          } catch {
            users.length = 0;
          }

          if (users.length > 0) {
            setSelectedExistingUsers(users);
          }
        } catch {
          setSelectedExistingUsers([]);
        }
      };

      loadResponsibles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId]);

  useEffect(() => {
    setValue('city_id', address?.city?.id);
    setValue('city_name', address?.city?.name);
    setValue('state_name', address?.city?.state?.name);
    setValue('street', address?.street);
    setValue('district', address?.district);
  }, [address]);

  useEffect(() => {
    if (watch('code_post').replace(/\D/g, '').length < 8) {
      setAddress(null);
      return;
    }
    if (!isFirstRender) {
      setLoadingCodepost(true);
      const timeout = setTimeout(() => {
        getCep(watch('code_post').replace(/\D/g, ''));
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [watch('code_post')]);

  // Carregar lista de usuários elegíveis para responsável de secretaria
  useEffect(() => {
    const loadEligibleUsers = async () => {
      setLoadingEligibleUsers(true);
      try {
        // TODO: Melhorar backend para filtrar usuários já vinculados a outras secretarias
        // Buscar usuários com group_id=6 (Responsável pela Secretaria)
        const params = {
          group_id: 6,
          per_page: 50, // Limitar resultados
        };
        const response = await reqApiUsers('get', { params });
        const users = response?.data?.data || [];

        // Por enquanto, exibir todos os usuários com group_id=6
        // Futuramente, filtrar aqui os que já estão em outras secretarias
        setEligibleUsers(users);
      } catch {
        setEligibleUsers([]);
      } finally {
        setLoadingEligibleUsers(false);
      }
    };

    loadEligibleUsers();
  }, []);

  useEffect(() => {
    setIsFirstRender(false);
  }, []);

  return (
    <FormBox>
      <Flex>
        <ReturnButton previousPage="secretaries" mb={5} />
        <PageTitle>{defaultValues?.name ? 'Editar' : 'Criar'} Secretaria</PageTitle>
      </Flex>

      <AlertModal
        alertMsg={
          <Text textAlign="center" fontWeight="bold" fontSize="25px">
            {!errorSecretaries
              ? `Secretaria ${defaultValues?.name ? 'editada' : 'criada'} com sucesso!`
              : errorSecretaries?.msg}
          </Text>
        }
        msgStatus={errorSecretaries ? 'error' : 'success'}
        closeOnOverlayClick={!!errorSecretaries}
        useSecondaryActions
        isOpenSecondary={isOpen}
        onCloseSecondary={onClose}
        ConfirmButton={
          <Button
            w="250px"
            boxShadow="0px 5px 10px #00000065"
            borderRadius="full"
            onClick={() => navigate('/secretaries')}
          >
            Retornar para a listagem
          </Button>
        }
      />

      <form noValidate onSubmit={handleSubmit(onSubmit, validationToast)}>
        <FormHeading>Informações Básicas</FormHeading>
        <Flex gap={5}>
          <Box flex={1}>
            <InputForm
              name={name?.name}
              label={name?.label}
              placeholder={name?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={1}>
            <SelectInputForm
              name={organ?.name}
              label={organ?.label}
              options={optionsOrgan}
              placeholder={organ?.placeholder}
              isRequired
              control={control}
              errors={errors}
            />
          </Box>
        </Flex>

        <Flex gap={5}>
          <Box flex={2}>
            <MaskedInputForm
              name={cellphone?.name}
              label={cellphone?.label}
              placeholder={cellphone?.placeholder}
              control={control}
              errors={errors}
              mask="(99) 99999-9999"
            />
          </Box>

          <Box flex={2}>
            <InputForm
              name={site?.name}
              label={site?.label}
              placeholder={site?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
          </Box>

          <Box flex={1}>
            <SwitchInputForm
              name={status?.name}
              label={status?.label}
              errors={errors}
              control={control}
            />
          </Box>
        </Flex>

        <FormHeading>Endereço</FormHeading>

        <Flex gap={5}>
          <Box flex={1}>
            <MaskedInputForm
              name={codePost?.name}
              label={codePost?.label}
              placeholder={codePost?.placeholder}
              control={control}
              errors={errors}
              mask="99999-999"
              isRequired
            />
            {errorCodepost?.status === 404 && (
              <Flex mt={5} mb={5}>
                <Alert borderRadius="10px" status="error">
                  <AlertIcon />
                  {errorCodepost?.msg}
                </Alert>
              </Flex>
            )}
            {loadingCodepost && (
              <Flex mt={5} mb={5}>
                <Alert borderRadius="10px" status="info" gap={5}>
                  <CircularProgress isIndeterminate size="25px" />
                  Buscando CEP
                </Alert>
              </Flex>
            )}
          </Box>
          <Box flex={1}>
            <InputForm
              name={city?.name}
              label={city?.label}
              placeholder={city?.placeholder}
              isDisabled
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={1}>
            <InputForm
              name={state?.name}
              label={state?.label}
              placeholder={state?.placeholder}
              isDisabled
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
        </Flex>

        <Flex gap={5}>
          <Box flex={2}>
            <InputForm
              name={street?.name}
              label={street?.label}
              placeholder={street?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={1}>
            <InputForm
              name={number?.name}
              label={number?.label}
              placeholder={number?.placeholder}
              type="number"
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={2}>
            <InputForm
              name={district?.name}
              label={district?.label}
              placeholder={district?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={2}>
            <InputForm
              name={complement?.name}
              label={complement?.label}
              placeholder={complement?.placeholder}
              register={register}
              errors={errors}
            />
          </Box>
        </Flex>

        <FormHeading>Responsável</FormHeading>

        <Flex gap={5}>
          <Box flex={1}>
            <InputForm
              name={responsible?.name}
              label={responsible?.label}
              placeholder={responsible?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={1}>
            <InputForm
              name={responsibleEmail?.name}
              label={responsibleEmail?.label}
              placeholder={responsibleEmail?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={1}>
            <MaskedInputForm
              name={responsiblePhone?.name}
              label={responsiblePhone?.label}
              placeholder={responsiblePhone?.placeholder}
              isRequired
              control={control}
              errors={errors}
              mask="(99) 99999-9999"
            />
          </Box>
          <Box flex={1}>
            <InputForm
              name={responsibleFunction?.name}
              label={responsibleFunction?.label}
              placeholder={responsibleFunction?.placeholder}
              isRequired
              register={register}
              errors={errors}
              isReadOnly
            />
          </Box>
        </Flex>

        <Box mt={3} mb={4}>
          <Alert borderRadius="10px" status="info" variant="left-accent">
            <AlertIcon />
            <Box>
              <Text fontSize="sm">
                <Text as="span" fontWeight="bold">
                  Vincular responsáveis adicionais:
                </Text>{' '}
                Você pode buscar e vincular usuários existentes abaixo, ou ajustar permissões
                posteriormente na tela{' '}
                <Text
                  as="a"
                  href="/permissions/list"
                  color="blue.600"
                  fontWeight="bold"
                  textDecoration="underline"
                >
                  Permissões
                </Text>
                .
              </Text>
            </Box>
          </Alert>
        </Box>

        <Box mb={5}>
          <Text fontSize="sm" fontWeight="medium" mb={2}>
            Buscar responsáveis de secretaria existente
          </Text>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Icon as={FiSearch} color="gray.400" />
            </InputLeftElement>
            <Input
              placeholder="Digite nome ou email para buscar usuários existentes..."
              onChange={handleUserSearchChange}
              bg="white"
            />
          </InputGroup>

          {searchingUsers && (
            <Flex mt={3} align="center" gap={2}>
              <Spinner size="sm" />
              <Text fontSize="sm" color="gray.600">
                Buscando usuários...
              </Text>
            </Flex>
          )}

          {userSearchResults.length > 0 && (
            <List
              mt={3}
              spacing={2}
              borderWidth="1px"
              borderRadius="md"
              maxH="200px"
              overflowY="auto"
              p={2}
            >
              {userSearchResults
                .filter((user) => !selectedExistingUsers.find((u) => u.id === user.id))
                .map((user) => (
                  <ListItem
                    key={user.id}
                    p={2}
                    borderRadius="md"
                    _hover={{ bg: 'gray.50', cursor: 'pointer' }}
                    onClick={() => handleSelectUser(user)}
                  >
                    <Text fontSize="sm" fontWeight="medium">
                      {user.name}
                    </Text>
                    <Text fontSize="xs" color="gray.600">
                      {user.email}
                    </Text>
                  </ListItem>
                ))}
            </List>
          )}

          {/* Lista de usuários elegíveis (pré-carregada) */}
          {!searchingUsers && userSearchResults.length === 0 && eligibleUsers.length > 0 && (
            <Box mt={4}>
              <Text fontSize="sm" fontWeight="medium" mb={2} color="gray.700">
                Responsáveis de secretaria disponíveis (
                {
                  eligibleUsers.filter(
                    (user) => !selectedExistingUsers.find((u) => u.id === user.id)
                  ).length
                }
                )
              </Text>
              <List
                spacing={2}
                borderWidth="1px"
                borderRadius="md"
                maxH="300px"
                overflowY="auto"
                p={2}
                bg="gray.50"
              >
                {eligibleUsers
                  .filter((user) => !selectedExistingUsers.find((u) => u.id === user.id))
                  .map((user) => (
                    <ListItem
                      key={user.id}
                      p={2}
                      borderRadius="md"
                      bg="white"
                      _hover={{ bg: 'blue.50', cursor: 'pointer', borderColor: 'blue.300' }}
                      borderWidth="1px"
                      borderColor="gray.200"
                      onClick={() => handleSelectUser(user)}
                    >
                      <Text fontSize="sm" fontWeight="medium">
                        {user.name}
                      </Text>
                      <Text fontSize="xs" color="gray.600">
                        {user.email}
                      </Text>
                      {user.cell_phone && (
                        <Text fontSize="xs" color="gray.500">
                          {user.cell_phone}
                        </Text>
                      )}
                    </ListItem>
                  ))}
              </List>
            </Box>
          )}

          {loadingEligibleUsers && !searchingUsers && (
            <Flex mt={3} align="center" gap={2}>
              <Spinner size="sm" />
              <Text fontSize="sm" color="gray.600">
                Carregando responsáveis disponíveis...
              </Text>
            </Flex>
          )}

          {selectedExistingUsers.length > 0 && (
            <Box mt={4}>
              <Text fontSize="sm" fontWeight="medium" mb={2}>
                {selectedExistingUsers.length} responsável(is) selecionado(s)
              </Text>
              <Flex gap={2} flexWrap="wrap">
                {selectedExistingUsers.map((user) => (
                  <Tag
                    key={user.id}
                    size="md"
                    borderRadius="full"
                    variant="solid"
                    colorScheme="blue"
                  >
                    <TagLabel>{user.name}</TagLabel>
                    <TagCloseButton onClick={() => handleRemoveUser(user.id)} />
                  </Tag>
                ))}
              </Flex>
            </Box>
          )}
        </Box>

        <Box mt={5}>
          <ImageInputForm
            defaultVal={defaultValues?.image}
            setImages={setImages}
            setIsUpping={setUploading}
            name={image?.name}
            label={image?.label}
            register={register}
            watch={watch}
            errors={errors}
          />
        </Box>

        <Flex mr="auto">
          <FormButton
            mt={4}
            w="100px"
            isLoading={isSubmitting || uploading}
            type="submit"
            textTransform="uppercase"
          >
            Salvar
          </FormButton>
        </Flex>
      </form>
    </FormBox>
  );
}
